var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHintRotateDevice(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Change_View",
    "data-name": "Change View",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 142.015,
    height: 96.672,
    viewBox: "0 0 142.015 96.672",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_304",
    "data-name": "Rechteck 304",
    width: 142.015,
    height: 96.672,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1286",
    "data-name": "Gruppe 1286",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2247",
    "data-name": "Pfad 2247",
    d: "M59.143,86.721c.736-2.231,2.006-3.951,4.429-4.512a7.742,7.742,0,0,1,1.734-.164q53.643-.011,107.285-.006c3.819,0,6.222,2.376,6.224,6.173q.008,26.588,0,53.175c0,3.86-2.4,6.27-6.267,6.279q-17.238.04-34.475.054-28.4.01-56.8-.009c-4.947,0-9.9-.134-14.84-.007-3.582.092-6.1-1.153-7.291-4.652Zm81.8,57.057c7.087-.043,14.175-.023,21.262-.026.373,0,.746-.035,1.1-.053V86.019H82.6v57.735a5.717,5.717,0,0,1,.931.007Zm-62.3-.018c.028-.343.056-.532.056-.721q0-28.1.017-56.2c0-.774-.253-1-1.009-.992-3.855.031-7.711.014-11.566.014-2.709,0-3.135.42-3.135,3.1q0,25.878,0,51.757a10.4,10.4,0,0,0,.052,1.4,1.679,1.679,0,0,0,1.7,1.622c4.592.04,9.184.018,13.887.018m88.636.011h4.666c2.575,0,3.008-.424,3.008-2.957q0-25.985,0-51.969a3.06,3.06,0,0,0-.1-1.378c-.314-.561-.825-1.379-1.3-1.415-2.066-.156-4.15-.067-6.272-.067Z",
    transform: "translate(-36.803 -51.05)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2248",
    "data-name": "Pfad 2248",
    d: "M89.864,162.868a3.713,3.713,0,1,1-3.713-3.713,3.713,3.713,0,0,1,3.713,3.713",
    transform: "translate(-51.299 -99.037)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2249",
    "data-name": "Pfad 2249",
    d: "M4.336,45.956a.944.944,0,0,1-.839-.51,31.344,31.344,0,0,1-2.324-5.858A30.954,30.954,0,0,1,.21,27.551,31.207,31.207,0,0,1,7.178,11.242a30.969,30.969,0,0,1,4.353-4.3A31.415,31.415,0,0,1,22.665,1.173,30.954,30.954,0,0,1,34.7.21,31.207,31.207,0,0,1,51.01,7.178a30.969,30.969,0,0,1,4.3,4.353,31.345,31.345,0,0,1,3.447,5.277.944.944,0,0,1-1.677.869,29.231,29.231,0,0,0-53.815,4.61A29.039,29.039,0,0,0,5.174,44.576a.945.945,0,0,1-.838,1.379Z",
    transform: "translate(-0.001 -0.001)",
    fill: "#00a2bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2250",
    "data-name": "Pfad 2250",
    d: "M144.744,40.157l-3.184-1.438a.695.695,0,0,0-.571,1.267l5.351,2.409,2.412-5.352a.695.695,0,1,0-1.267-.571L146.032,39.7",
    transform: "translate(-87.478 -22.44)",
    fill: "#00a2bb"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHintRotateDevice);
export default __webpack_public_path__ + "static/media/hint-rotate-device.5edcb9dc03358343512480f8172b83d0.svg";
export { ForwardRef as ReactComponent };